import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MeusContatosCreatePage } from './meus-contatos-create.page';

const routes: Routes = [
  {
    path: '',
    component: MeusContatosCreatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeusContatosCreatePageRoutingModule {}
